import { afterFrame } from '@elastic/apm-rum-core';
export function routeHooks(router, apm) {
  var transaction;
  router.beforeEach(function (to, from, next) {
    var matched = to.matched || [];
    var path = to.path;

    if (matched.length > 0) {
      path = matched[matched.length - 1].path || path;
    }

    transaction = apm.startTransaction(path, 'route-change', {
      managed: true,
      canReuse: true
    });
    next();
  });
  router.afterEach(function () {
    afterFrame(function () {
      return transaction && transaction.detectFinish();
    });
  });
  router.onError(function () {
    transaction && transaction.end();
  });
}